<template>
  <div v-if="showGetSubscriptionBtn || !loggedInUser" :class="wrapperClass">
    <NuxtLink v-if="showGetSubscriptionBtn" to="/keuze" class="btn btn-primary">
      {{ $label('common.upgrade') }}
    </NuxtLink>

    <div v-if="!loggedInUser" class="d-flex flex-wrap flex-gap-16">
      <NuxtLink
        class="btn btn-primary"
        to="/aanmelden"
        @click.enter="pushTrackingEvent('register')"
      >
        {{ $label('user.signUp.register') }}
      </NuxtLink>
      <BaseButton variant="secondary" @click="openUserMenu()">
        {{ $label('common.login') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '~/stores/user'
import { PAGES } from '~/utils/constants'
import { useBook } from '~/composables/useBook'
import { useDrawer } from '~/composables/useDrawer'

export default {
  props: {
    book: {
      type: Object,
      required: true
    },
    wrapperClass: {
      type: String,
      default: 'mt-40'
    }
  },
  setup() {
    const { isCurrentMonth, isNextMonth } = useBook()
    const { updateDrawerState } = useDrawer()
    const userStore = useUserStore()

    return {
      isCurrentMonth,
      isNextMonth,
      updateDrawerState,
      userStore
    }
  },
  computed: {
    loggedInUser() {
      return this.userStore.loggedInUser
    },
    hasValidSubscription() {
      return this.userStore.hasValidSubscription
    },
    ebookDownloadable() {
      return this.book.download?.ebook?.downloadable
    },
    audioBookDownloadable() {
      return this.book.download?.audioBook?.downloadable
    },
    bookDownloadable() {
      return this.ebookDownloadable || this.audioBookDownloadable
    },
    hasPausedSubscription() {
      return this.loggedInUser && this.loggedInUser.pauseSubscription
    },
    isCurrentMonthBook() {
      return this.isCurrentMonth(this.book.categoryCode)
    },
    isNextMonthBook() {
      return this.isNextMonth(this.book.categoryCode)
    },
    showGetSubscriptionBtn() {
      return (
        this.loggedInUser &&
        !this.hasValidSubscription &&
        !this.hasPausedSubscription &&
        !this.bookDownloadable &&
        (this.isCurrentMonthBook || this.isNextMonthBook)
      )
    },
    getSubBtnLink() {
      return PAGES.chooseSubscription
    }
  },
  methods: {
    openUserMenu() {
      const loginMenu = {
        menuPositionClass: 'right',
        title: 'user.signIn.title',
        component: 'base-login',
        props: {
          isHeadingShown: false,
          loginFormPrefix: 'login-',
          shouldPreventRedirect: true,
          inSlideMenu: true
        }
      }

      this.updateDrawerState({
        drawerOptions: loginMenu,
        isDrawerShown: true
      })

      this.pushTrackingEvent('login')
    },
    pushTrackingEvent(button) {
      this.$gtmTracking.push({
        event: 'interact_event',
        eventAction: 'click',
        eventCategory: `MonthlyBooksDetails || ${button}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@include media-breakpoint-down(md) {
  a,
  button {
    width: 100%;
  }
}
</style>
